import "./i18n/config";
import "@web3jskit/walletkit/style.css";
import "./styles/index.css";
import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";

createRoot(document.getElementById("root")!).render(<App />);
